/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  HeroSection,
  TimelineComp,
  BackArrowComp,
  TimelineDetailModal,
  TransactionReceiptModal,
} from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMBlockchainProof,
  useSMPayoutDetailPage,
  useSMSendReminder,
  useSMTransactionList,
  useSMUpdatePayoutStatus,
  updatePayoutStatusMachine,
} from '@pages/PayoutDetailPage/machines';
import { PayoutDetailPageService } from '@pages/PayoutDetailPage/services';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { usePolicyId } from '../provider';
import { useLocation, useNavigate } from 'react-router-dom';
const getSrv = () => {
  return vappContainer.get<PayoutDetailPageService>(
    PayoutDetailPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [receiptModal, setReceiptModal] = useState<boolean>(false);
  const [receiptData, setReceiptData] = useState<any>();
  const [cardId, setCardId] = useState<string>('');
  const { policyNumber } = usePolicyId();

  const theme = useTheme();
  // const history = useHistory();
  const navigation = useNavigate();
  const { state } = useLocation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [buttons, setButtons] = useState<any>([]);
  const {
    payoutdetailPageMachine,
    payoutdetailPageState,
    payoutdetailPageSend,
  } = useSMPayoutDetailPage({});

  const {
    updatePayoutStatusMachine,
    updatePayoutStatusSend,
    updatePayoutStatusState,
  } = useSMUpdatePayoutStatus({});

  const { sendReminderMachine, sendReminderSend, sendReminderState } =
    useSMSendReminder({});

  const { blockchainProofMachine, blockchainProofSend, blockchainProofState } =
    useSMBlockchainProof({});

  const { transactionListMachine, transactionListSend, transactionListState } =
    useSMTransactionList({});

  const srv = getSrv();
  console.log('heroSection', payoutdetailPageState?.event?.data?.value);

  useEffect(() => {
    if (state?.detail) {
      srv?.agent
        ?.getButtonPayoutDetailContentSync({
          ...state?.detail,
          ...state?.eventData,
        })
        ?.then((res: any) => setButtons(res));
    }
  }, []);

  const onRefreshClick = () => {
    payoutdetailPageState('TRIGGER_REFRESH', {});
  };
  const onRefresh = () => {
    payoutdetailPageSend('TRIGGER_REFRESH', {});
  };

  const _renderErrorNotification = () => {
    if (payoutdetailPageState?.matches('RENDER_PAYOUT_DETAIL_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.error
            ?.getPageContent || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (updatePayoutStatusState?.matches('UPDATE_PAYOUT_STATUS_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.error
            ?.updatePayout || {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
  };

  const onHeroButtonClick = (key: string) => {
    console.log(`button key`, key);

    if (key === 'payoutKyc') {
      sendReminderSend('START', {});
    }

    if (key === 'processPayout') {
      if (!showModal) {
        setShowModal(true);
      }
    }
  };

  const onGoBack = () => {
    //history.goBack();
    navigation(-1);
  };

  const onCardClick = (id: string) => {
    console.log(`id clicked`, id);
    blockchainProofSend('START', {
      payload: {
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId: id,
      },
    });
    let _cardDetail = srv?.agent?.getFormatTimelinePayoutDetailProps({
      ...transactionListState?.event?.data?.value?.timelineData,
      cardId: id,
    });
    console.log('card detail', _cardDetail);

    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCardClose = (id: string) => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };

  const getMatchedNumber = (str: string) => {
    return parseFloat(str.replace(/[^\d\.]*/g, '')).toFixed(2);
  };

  const onPaymentSubmit = (data: any) => {
    console.log(`data`, data);
    if (showModal) {
      setShowModal(!showModal);
    }
    updatePayoutStatusSend('START', {
      payload: {
        ...data,
        payoutId: state?.detail?.id,
      },
    });
  };

  const onTriggerModal = (data: any) => {
    console.log('Receipt modal trigger', data);
    setReceiptData(data);
    if (!receiptModal) {
      setReceiptModal(true);
    }
  };

  const onReceiptModalClose = () => {
    if (receiptModal) {
      setReceiptModal(!receiptModal);
    }
  };

  const _renderNestedModal = () => {
    if (receiptModal) {
      return (
        <TransactionReceiptModal
          showModal={receiptModal}
          modalTitle={'Transaction Receipt'}
          // data={receiptData}
          data={blockchainProofState?.event?.data?.value || {}}
          onDeny={onReceiptModalClose}
        />
      );
    }
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          // size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onPaymentSubmit}
          onHide={() => setShowModal(false)}
          title={'Update Payout Status'}
          tweetyWidgetProps={{
            fields:
              srv?.agent?.getStaticPayoutDetailContentSync()?.updatePayout
                ?.FIELDS,
            layout:
              srv?.agent?.getStaticPayoutDetailContentSync()?.updatePayout
                ?.layout,
            dynamicLayout:
              srv?.agent?.getStaticPayoutDetailContentSync()?.updatePayout
                ?.dynamicLayout,
            initialData: {
              amount: getMatchedNumber(
                payoutdetailPageState?.event?.data?.value?.coverage
              ),
            },
          }}
        />
      );
    }
    if (cardModal) {
      let _temp = srv?.agent?.getFormatTimelinePayoutDetailProps({
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
          onTriggerModal={onTriggerModal}
        />
      );
    }
  };

  const _renderPayoutDetail = () => {
    console.log('policydata', payoutdetailPageState?.event?.data?.value);
    if (updatePayoutStatusState?.matches('UPDATE_PAYOUT_STATUS')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.loading
            ?.updatePayout || {})}
        />
      );
    }
    if (sendReminderState?.matches('SEND_REMINDER')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.loading
            ?.sendReminder || {})}
        />
      );
    }
    if (state?.detail) {
      let productDetail = srv?.agent?.getFormatPolicyPayoutDetailProps(
        state?.detail
      );
      console.log(
        `timeline Details:`,
        payoutdetailPageState?.event?.data?.value
      );
      let _tempItems = [...productDetail?.accordionItems];
      if (
        Array.isArray(payoutdetailPageState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ...payoutdetailPageState?.event?.data?.value?.accordionItems,
        ];
      }
      if (
        Array.isArray(transactionListState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ..._tempItems,
          ...transactionListState?.event?.data?.value?.accordionItems,
        ];
      }
      return (
        <>
          <HeroSection
            {...(payoutdetailPageState?.event?.data?.value || {})}
            onHeroButtonClick={onHeroButtonClick}
            carouselItems={
              payoutdetailPageState?.event?.data?.value?.carouselItems ?? []
            }
            buttons={buttons}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (payoutdetailPageState?.matches('RENDER_PAYOUT_DETAIL')) {
      let _tempItems: any = [];
      if (
        Array.isArray(payoutdetailPageState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ...payoutdetailPageState?.event?.data?.value?.accordionItems,
        ];
      }
      if (
        Array.isArray(transactionListState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ..._tempItems,
          ...transactionListState?.event?.data?.value?.accordionItems,
        ];
      }
      return (
        <>
          <HeroSection
            {...(payoutdetailPageState?.event?.data?.value || {})}
            accordionItems={_tempItems}
            onHeroButtonClick={onHeroButtonClick}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (payoutdetailPageState?.matches('GET_PAYOUT_DETAIL')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.loading
            ?.loadingProfile || {})}
        />
      );
    }
    return null;
  };

  const _renderNotification = () => {
    if (updatePayoutStatusState?.matches('UPDATE_PAYOUT_STATUS_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.notifications
            ?.updatePayout || {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
    if (sendReminderState?.matches('SEND_REMINDER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPayoutDetailContentSync()?.notifications
            ?.sendReminder || {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    return <BackArrowComp />;
  };

  const _renderAnchorLink = () => {
    return (
      <a
        download={payoutdetailPageState?.event?.data?.value?.title}
        href={payoutdetailPageState?.event?.data?.value?.policyDocument}
        title="Download pdf document"
        id="downloadPolicy"
        style={{ display: 'none' }}
      />
    );
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderPayoutDetail()}
        {_renderErrorNotification()}
        {_renderNotification()}
        {_renderAnchorLink()}
        {_renderModal()}
        {_renderNestedModal()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
